"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Subtitle = exports.StyledMedia = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Media = _interopRequireDefault(require("../Media"));

var _Typography = require("../Typography");

var nonForwardedProps = ['hasTitle', 'hasCaption', 'hasSubitle'];
var StyledMedia = (0, _styled.default)(_Media.default, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !nonForwardedProps.includes(prop);
  }
})(function (_ref) {
  var space = _ref.theme.space,
      hasTitle = _ref.hasTitle,
      hasSubitle = _ref.hasSubitle,
      hasCaption = _ref.hasCaption;
  return {
    marginBottom: hasCaption ? space.large : 'auto',
    marginTop: hasTitle || hasSubitle ? space.large : 'auto'
  };
});
exports.StyledMedia = StyledMedia;
var Subtitle = (0, _styled.default)(_Typography.Body)(function (_ref2) {
  var space = _ref2.theme.space,
      hasTitle = _ref2.hasTitle;
  return {
    marginTop: hasTitle ? space.medium : '0'
  };
});
exports.Subtitle = Subtitle;